import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import poklon from "../img/poklon-paket.png";


function PrijavaBezPost() {
  return (
<Link to="/prijavabezpl">
   <div className="menu-card">
           <div className="text majice">
             <h2>Klasična prijava</h2>
         <p>Imamo paket i za ovu opciju</p>
         <p>Poklon paket od Mrle Garage ekipe</p>
         
           <Link className="majice" to="/prijavabezpl">
               <img src={poklon} className="logo" alt="logo" height="280" />
           </Link>
           <p className="mt-4">Kotizaciju plaćaš na ulazu</p>
           </div>
       </div>
</Link>
  );
}

export default PrijavaBezPost;